// src/pages/Home.jsx
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function Home() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#050A1F] to-[#0B112E] text-white flex flex-col items-center justify-center overflow-hidden relative">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="text-center z-10"
      >
        <h1 className="text-5xl md:text-7xl font-extrabold bg-gradient-to-r from-cyan-400 via-purple-500 to-pink-500 bg-clip-text text-transparent">
          Vidra Website Builder
        </h1>
        <p className="text-gray-300 mt-6 text-lg max-w-xl mx-auto">
          Build and publish your school website in minutes — with AI, themes, and real-time editing.
        </p>
        <Link to="/login">
          <button className="mt-10 px-8 py-3 bg-gradient-to-r from-cyan-500 to-purple-600 rounded-xl text-white font-semibold shadow-lg hover:scale-105 transition-all">
            🚀 Start Building
          </button>
        </Link>
      </motion.div>

      <motion.div
        className="absolute inset-0 -z-10 overflow-hidden"
        animate={{
          background: [
            "radial-gradient(circle at 20% 30%, rgba(0,255,255,0.1), transparent 40%)",
            "radial-gradient(circle at 80% 70%, rgba(139,92,246,0.15), transparent 40%)",
          ],
        }}
        transition={{ duration: 8, repeat: Infinity, repeatType: "mirror" }}
      />
    </div>
  );
}
